import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="scroller"

export default class extends Controller {
  connect() {
    requestAnimationFrame(() => {
      this.element.scrollIntoView({ behavior: "smooth", block: this.element.dataset.block || "start" })
    })
  }
}